import React from 'react';
import { browserHistory } from 'react-router';
import XpressTemplateCreateForm from '../XpressTemplateCreateForm';

class XpressTemplateCreatePage extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    statusMessage: '',
  };

  goBack() {
    browserHistory.goBack();
  }

  render() {
    let barColor = '#216887';

    return (
      <div className='xtemplate-page'>
        <div className='title-row page-title'>
          <div
            className='title-back cursor-pointer'
            onClick={this.goBack.bind(this)}
            style={{ background: barColor }}
          >
            <i className='fa fa-chevron-left' />
          </div>
          <div className='title' style={{ paddingLeft: '10px', background: barColor }}>
            Create Xpress Template
          </div>
        </div>
        <XpressTemplateCreateForm {...this.props} />
      </div>
    );
  }
}

export default XpressTemplateCreatePage;



// WEBPACK FOOTER //
// ./src/components/pages/XpressTemplateCreatePage.js